angular.module('bmsApp.settings')
	.controller('NotificationTemplateCtrl', NotificationTemplateCtrl);

NotificationTemplateCtrl.$inject = [
	'$scope',
	'$state',
	'$q',
	'notify',
	'NotificationTemplateSvc',
	'TextInsert',
	'InstanceSvc',
];

function NotificationTemplateCtrl($scope, $state, $q, notify, NotificationTemplateSvc, TextInsert, InstanceSvc) {
	let self = this;
	let handlers = {};
	self.ecomEnabled = InstanceSvc.instance.ecomEnabled();

	angular.extend(self, {
		loading: null,
		handlers: handlers,
		options: {},
		templatePlaceholders: {
			jobComplete:[
				{
					value: '[Order Number]',
					label: 'Order Number',
				},
				{
					value: '[Review Site Name]',
					label: 'Review Site Name',
				},
				{
					value: '[Review Site URL]',
					label: 'Review Site URL',
				},
				{
					value: '[BMS Feedback URL]',
					label: 'BMS Feedback URL',
				},
				{
					value: '[Licence Primary Telephone Number]',
					label: 'Licence Primary Telephone Number',
				},
			],
		}
	});

	this.$onInit = () => {

		initForm();
		var params = {
			filter: {
				typeIn: [
					'job_complete',
					'ecom_job_complete',
				]
			},
		}
		let promises = {
			templates: NotificationTemplateSvc.read()
				.then((response) => {
					self.templates = response.data.templates;
					angular.forEach(self.templates, (template) => {
						if (template.type === 'job_complete') {
							// self.form.job_complete.enabled = true;
							self.form.job_complete.email.message = template.email_message;
							handlers.showPreview(self.form.job_complete.email);
						}
						else if (template.type === 'ecom_job_complete') {
							// self.form.ecom_job_complete.enabled = true;
							self.form.ecom_job_complete.email.message = template.email_message;
							handlers.showPreview(self.form.ecom_job_complete.email);
						}
					});
				}),
		};
		$q.all(promises)
			.then((response) => {
				self.loading = false;
			});
	};

	function initForm() {
		self.form = {};
		if(InstanceSvc.instance.isSM()) {
			self.form.job_complete = {
				enabled: true,
				email: {
					message: '',
				},
			};
		}
		self.form.ecom_job_complete = {
			enabled: true,
			email: {
				message: '',
			},
		};
	}

	// Handlers --------------------------------------------------------------------------------------------------------
	handlers.insertPlaceholder = (el, text) => {
		TextInsert.insert(document.getElementById(el), text);
	};

	handlers.showPreview = (obj) => {
		let message = obj.message;
		console.log(obj);
		message = message.replace(/\[Order Number\]/g, '#3092');
		message = message.replace(/\[Review Site Name]/g, 'Google');
		message = message.replace(/\[Review Site URL]/g, 'https://g.page/servicemaster-clean-branch?share');
		message = message.replace(/\[BMS Feedback URL]/g, 'https://feedback.servicemaster.org.uk/feedback/s73h');
		message = message.replace(/\[Licence Primary Telephone Number]/g, '0122 638 3846');

		angular.extend(obj, {
			preview: message,
		});
	};

	handlers.submitClick = function () {
		NotificationTemplateSvc.save(self.form).then((response) => {
			notify({
				message: 'Templates successfully saved'
			});
		});
	};
}
